var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSustainableLeafIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13290",
    "data-name": "Group 13290",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10.855,
    height: 17,
    viewBox: "0 0 10.855 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5199",
    "data-name": "Rectangle 5199",
    width: 10.855,
    height: 17,
    fill: "#00bc4b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13289",
    "data-name": "Group 13289",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45504",
    "data-name": "Path 45504",
    d: "M6.481,6.036a8.382,8.382,0,0,0-3.619,3,5.683,5.683,0,0,0,.926,7.147c.125.117.712.541.723.646s-.093.185-.207.169a5.179,5.179,0,0,1-.781-.588C1.086,14.324-.84,11.114.374,7.837A7.367,7.367,0,0,1,3.825,4.347C6.021,3.162,8.164,3.283,9.682.874c.09-.143.385-.8.42-.831a.183.183,0,0,1,.21-.019A3.919,3.919,0,0,1,10.6,1.135c.944,5.49-.653,10.707-6.8,11.495-.63.081-.83.223-.885-.507a5.86,5.86,0,0,1,.97-3.277A12.61,12.61,0,0,1,6.481,6.036",
    transform: "translate(0 0)",
    fill: "#00bc4b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainableLeafIcon);
export default __webpack_public_path__ + "static/media/sustainable-leaf-icon.e381d1e763f04b72a00a5d177c7490ee.svg";
export { ForwardRef as ReactComponent };